<div class="dialog-container">
    <h1 mat-dialog-title>{{ 'CONVERSION.DIALOG.TITLE' | translate }}</h1>
    <div mat-dialog-content>
        <form [formGroup]="conversionForm">
            <mat-form-field>
                <mat-label>{{ 'CONVERSION.DIALOG.TYPE.LABEL' | translate }}</mat-label>
                <mat-select formControlName="type">
                    <mat-option *ngFor="let conversionType of conversionTypes" [value]="conversionType">
                        {{ 'CONVERSION.DIALOG.TYPE.' + conversionType.toUpperCase() | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <ng-container *ngIf="conversionForm.controls.type.value === 'template'">
                <mat-form-field>
                    <mat-label>{{ 'COMMON.DIALOG.DESCRIPTION.LABEL' | translate }}</mat-label>
                    <input
                        type="text"
                        matInput
                        placeholder="{{ 'COMMON.DIALOG.DESCRIPTION.PLACEHOLDER' | translate }}"
                        formControlName="templateDescription"
                    />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>{{ 'COMMON.DIALOG.PRIMARY_SCHEME.LABEL' | translate }}</mat-label>
                    <input
                        type="text"
                        matInput
                        placeholder="{{ 'COMMON.DIALOG.PRIMARY_SCHEME.PLACEHOLDER' | translate }}"
                        formControlName="primarySchemes"
                    />
                </mat-form-field>
            </ng-container>
        </form>
    </div>
    <div mat-dialog-actions fxLayoutAlign="end">
        <button mat-button [mat-dialog-close]="false">{{ 'COMMON.DIALOG.CANCEL' | translate }}</button>
        <button
            mat-raised-button
            color="primary"
            [disabled]="conversionForm.controls.type.value !== 'unit-test' && !conversionForm.valid"
            [mat-dialog-close]="dialogResult"
        >
            {{ 'CONVERSION.DIALOG.CONVERT' | translate }}
        </button>
    </div>
</div>
